import { default as testingN38uR0wN0tMeta } from "/codebuild/output/src947570429/src/nuxt-skupinaklik/pages/testing.vue?macro=true";
import { default as pagetYdVtMEeUuMeta } from "/codebuild/output/src947570429/src/nuxt-skupinaklik/.srovnejto/storyblok/pages/storyblok/page?macro=true";
import { default as headers_45testHI5PnffI2fMeta } from "/codebuild/output/src947570429/src/nuxt-skupinaklik/.srovnejto/storyblok/pages/storyblok/headers-test?macro=true";
import { default as sectionWRM8kJRrx9Meta } from "/codebuild/output/src947570429/src/nuxt-skupinaklik/.srovnejto/storyblok/pages/adviser/section?macro=true";
import { default as media8P5iivIisIMeta } from "/codebuild/output/src947570429/src/nuxt-skupinaklik/.srovnejto/storyblok/pages/press/media?macro=true";
import { default as press9VVVCT704MMeta } from "/codebuild/output/src947570429/src/nuxt-skupinaklik/.srovnejto/storyblok/pages/press/press?macro=true";
import { default as slugkMcm9jB5Y9Meta } from "/codebuild/output/src947570429/src/nuxt-skupinaklik/.srovnejto/storyblok/pages/press/slug?macro=true";
export default [
  {
    name: "testing",
    path: "/testing",
    component: () => import("/codebuild/output/src947570429/src/nuxt-skupinaklik/pages/testing.vue")
  },
  {
    name: pagetYdVtMEeUuMeta?.name,
    path: "/:all(.*)*",
    component: () => import("/codebuild/output/src947570429/src/nuxt-skupinaklik/.srovnejto/storyblok/pages/storyblok/page")
  },
  {
    name: headers_45testHI5PnffI2fMeta?.name,
    path: "/headers-test",
    component: () => import("/codebuild/output/src947570429/src/nuxt-skupinaklik/.srovnejto/storyblok/pages/storyblok/headers-test")
  },
  {
    name: sectionWRM8kJRrx9Meta?.name,
    path: "/radce/",
    component: () => import("/codebuild/output/src947570429/src/nuxt-skupinaklik/.srovnejto/storyblok/pages/adviser/section")
  },
  {
    name: sectionWRM8kJRrx9Meta?.name,
    path: "/radce/:slug(.*)",
    component: () => import("/codebuild/output/src947570429/src/nuxt-skupinaklik/.srovnejto/storyblok/pages/adviser/section")
  },
  {
    name: media8P5iivIisIMeta?.name,
    path: "/pro-media",
    component: () => import("/codebuild/output/src947570429/src/nuxt-skupinaklik/.srovnejto/storyblok/pages/press/media")
  },
  {
    name: press9VVVCT704MMeta?.name,
    path: "/press",
    component: () => import("/codebuild/output/src947570429/src/nuxt-skupinaklik/.srovnejto/storyblok/pages/press/press")
  },
  {
    name: slugkMcm9jB5Y9Meta?.name,
    path: "/press/:slug",
    component: () => import("/codebuild/output/src947570429/src/nuxt-skupinaklik/.srovnejto/storyblok/pages/press/slug")
  }
]